<template>
  <div>
    <transition name="opacity">
      <div
        v-if="show"
        class="ShareModal__backdrop"
      ></div>
    </transition>
    <transition name="fade">
      <div
        v-if="show"
        class="ShareModal"
        @click="close"
      >
        <div>
          <a
            target="_blank"
            rel="noreferrer, noopener"
            :href="tw"
            @click="$gtag.event('clicked_share_twitter', {
              'event_category' : 'outbound',
              'event_label' : 'share_twitter'
            })"
            class="button button--white twitter"
          >
            <img
              width="24"
              height="24"
              src="@/assets/icons/twitter-share.svg"
            />
            <span>Twitter</span>
          </a>
          <a
            target="_blank"
            rel="noreferrer, noopener"
            :href="fb"
            @click="$gtag.event('clicked_share_facebook', {
              'event_category' : 'outbound',
              'event_label' : 'share_facebook'
            })"
            class="button button--white facebook"
          >
            <img
              width="24"
              height="24"
              src="@/assets/icons/facebook-share.svg"
            />
            <span>Facebook</span>
          </a>
          <a
            target="_blank"
            rel="noreferrer, noopener"
            :href="wa"
            @click="$gtag.event('clicked_share_whatsapp', {
              'event_category' : 'outbound',
              'event_label' : 'share_whatsapp'
            })"
            class="button button--white whatsapp"
          >
            <img
              width="24"
              height="24"
              src="@/assets/icons/whatsapp-share.svg"
            />
            <span>Whatsapp</span>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from "vue";
import sharing from "@/share";
export default {
  props: ["show", "title"],
  setup(props, { emit }) {
    const fb = ref(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        sharing.main.url
      )}`
    );
    const tw = ref(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        sharing.main.tw + " " + sharing.main.url
      )}`
    );
    const wa = ref(
      `whatsapp://send?text=${encodeURIComponent(
        sharing.main.wa + " " + sharing.main.url
      )}`
    );
    function close() {
      emit("close");
    }
    function share(provider) {
      alert(`Share on ${provider}`);
    }
    return {
      close,
      share,
      fb,
      tw,
      wa,
    };
  },
};
</script>

<style>
.ShareModal__backdrop {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.ShareModal {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.ShareModal > div {
  height: 100px;
  display: flex;
  align-items: center;
  background: white;
  padding: 0 40px;
  border-radius: 200px;
}

.ShareModal button > img {
  width: 18px;
  height: 18px;
}

.ShareModal .button {
  line-height: 52px;
  height: 52px;
  width: 52px;
  border-radius: 52px;
  min-width: auto;
  padding: 0;
  margin: 0 10px;

  position: relative;
}
.ShareModal .button span {
  position: absolute;
  bottom: -38px;
  font-size: 12px;
}
.ShareModal .button img {
  margin: 0;
}
.twitter {
  background-color: #e3f6ff !important;
  color: #0198dc !important;
}
.facebook {
  background-color: #e9f2ff !important;
  color: #365ba5 !important;
}
.whatsapp {
  background-color: #e7faeb !important;
  color: #3fbd57 !important;
}

@media screen and (min-width: 800px) {
  .ShareModal .button {
    width: auto;
    padding: 20px;
  }
  .ShareModal .button img {
    margin-right: 10px;
  }
  .ShareModal .button span {
    position: relative;
    bottom: 0;
  }
}
</style>